import { OnboardDeviceHardwareConfiguration } from '../../interfaces';
import { useAppSelector } from '../../store/hooks';
import { selectOnboardDevicesHardwareConfigurations } from '../../store/devices.reducer';
import { createEntityFilterOperators, EntityFilterInput, EntityFilterInputProps } from './EntityFilterInput';

export const HardwareConfigurationFilterInput = (
    props: Omit<EntityFilterInputProps<OnboardDeviceHardwareConfiguration>, 'options'>,
) => {
    const hardwareConfigurations: OnboardDeviceHardwareConfiguration[] =
        useAppSelector(selectOnboardDevicesHardwareConfigurations) ?? [];

    return <EntityFilterInput {...props} options={hardwareConfigurations} />;
};

export const SERVER_HARDWARE_CONFIGURATION_FILTER_OPERATORS = createEntityFilterOperators(
    HardwareConfigurationFilterInput,
);
